import React from 'react';

const ReelItemSkeleton = () => {
    return (
        <div className="reel-item" style={{ backgroundColor: '#1a1a1a' }}>
            <div className="reel-player-wrapper">
                <div className="w-full h-full bg-gray-700 animate-pulse"></div>
            </div>
            <div className="reel-ui-container">
                <div className="reel-details">
                    <div className="author-info">
                        <div className="w-10 h-10 rounded-full bg-gray-600 animate-pulse"></div>
                        <div className="w-24 h-4 bg-gray-600 rounded animate-pulse ml-2"></div>
                    </div>
                    <div className="w-48 h-4 bg-gray-600 rounded animate-pulse mt-2"></div>
                </div>
                <div className="reel-actions">
                    <div className="w-8 h-8 rounded-full bg-gray-600 animate-pulse"></div>
                    <div className="w-8 h-8 rounded-full bg-gray-600 animate-pulse"></div>
                    <div className="w-8 h-8 rounded-full bg-gray-600 animate-pulse"></div>
                    <div className="w-8 h-8 rounded-full bg-gray-600 animate-pulse"></div>
                    <div className="w-8 h-8 rounded-full bg-gray-600 animate-pulse"></div>
                    <div className="w-8 h-8 rounded-full bg-gray-600 animate-pulse"></div>
                </div>
            </div>
        </div>
    );
};

export default ReelItemSkeleton;
